import {config} from '@modules/config';

export const interFontFace = `
/* Inter Regular */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 400;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-regular.5a6fdf7acc89c02b23bac897744556c612eb0576.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-regular.0890ce1b90d4ff0ed966266da092146c302da2cc.woff')
			format('woff');
}

/* Inter Medium */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 500;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-medium.20aefd2d6df4c2b84473e7372d016ad4638ed3e7.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-medium.00b9484e50765550e2028680bb2c762d81385e40.woff')
			format('woff');
}

/* Inter Semibold */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 600;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-semibold.ab2de210c4b06f71ca98c4782c87ac9913db2ffe.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-semibold.30459d2ff803a1f60b25f15e9ffd41c16434b4f4.woff')
			format('woff');
}

/* Inter Bold */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 700;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-bold.5c4ac79345d957c3b7ecbbd26ca0c850a9b97f50.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-bold.c3e782e1d5d8e129b0276a7cb28983e565476360.woff')
			format('woff');
}

/* Inter Black */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 900;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-black.5ebd2a3a07c5dfedb0f2763699f80a98d662f853.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-black.64d350860d050b29ed4b86f1429d1c7057275389.woff')
			format('woff');
}
`;

export const deezerProductFontFace = `
/* Deezer Light */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 300;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Light.efd35bdb0915246feab41d1358b8cd5085fd20cd.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Light.cfee2dd7c4becdda1c9e8e9d9f4b6ba61f361bc3.woff')
			format('woff');
}

/* Deezer Regular */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 400;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Regular.70f89899e36fd31e61516d3d8735072f84e1834c.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Regular.fdde3d408773a19ee0b563751b99c4480516924d.woff')
			format('woff');
}

/* Deezer Medium */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 500;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Medium.daf0b392651bce99e22271f127d6798f00f7a1f7.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Medium.58cb919ec641feddea21f6a7afd51060691af3ce.woff')
			format('woff');
}

/* Deezer Bold */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 700;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Bold.12a16421bc0c1a0e11b324a8ba1f3035aae0ada2.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Bold.14ce4332645cb3ca0f164d257e880853ed262798.woff')
			format('woff');
}

/* Deezer Extra Bold */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 800;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Extrabold.ff5d8428e4fe802f91d53a06857feb145b0a435d.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Extrabold.a1c06d3aa3a0d709767a0e592c1bac25af1f6944.woff')
			format('woff');
}
`;
